import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getConnectedAppsQueryOptions } from '@/_pages/connected-apps/api-service';

export const Route = createFileRoute('/_private/connected-apps/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getConnectedAppsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
